<canvas #canvas hidden></canvas>
<div *ngIf="finalImage">
    <span style="font-size: 18px;">Facebook Post Preview 👉</span>
    <br><br>
    <img [src]="finalImage" alt="Final Generated Image" />
</div>